export const sanitizeMacAddress = (value = '') => value.replace(/[^A-Za-z0-9]/g, '');